import { CerPromptService } from "@cer/cer-ui/cer-ui-prompt.service";

export class CerLinkedAttachmentUploadProgress {
  
  constructor(private ui: CerPromptService) { }

  private isProgress = false;
  public update(percentage: number, isComplete: boolean = false) {
    const txt = (percentage == 100 ? "Behandler" : "Overfører: " + percentage + "%");
    isComplete ? this.ui.operationEnd(null,true) : this.isProgress ? this.ui.operationProgress(txt) : this.ui.operationBegin(txt);
    this.isProgress = true;
  }
}

export class CerLinkedAttachmentUploader {

  public static uploadFormData(formData: FormData, postUrl: string, progress: CerLinkedAttachmentUploadProgress): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener("progress", (e) => {
        if (e.lengthComputable) {
          const percentage = Math.round((e.loaded * 100) / e.total);
          progress.update(percentage);
        }
      });
      xhr.upload.addEventListener("load", (e) => {
        progress.update(100);
      });
      xhr.onreadystatechange = function () {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          progress.update(100, true);
          if (xhr.status < 400) {
            progress.update(100,true);
            resolve(xhr.responseText);
          }
          else {
            reject(xhr.responseText);
          }
        }
      };
      xhr.onerror = function (e: ProgressEvent) { 
        reject(JSON.stringify(e)) 
      };
      xhr.onabort = function (e: ProgressEvent) { 
        reject(JSON.stringify(e))
      };
      xhr.open("POST", postUrl);
      xhr.send(formData);
    });
  }
}
